import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function DemeritEducationReservationFailBottomSheet() {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10330')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T10331')}</strong>
        </div>
        <div className="bottom_sheet_box">
          <div className="divider" />
          <p className="bottom_sheet_text">{t('T10332')}</p>
          <p className="bottom_sheet_text">{t('T10333')}</p>
        </div>
        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T10221')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemeritEducationReservationFailBottomSheet;
